/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type VerifySignForbiddenErrorCode = (typeof VerifySignForbiddenErrorCode)[keyof typeof VerifySignForbiddenErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifySignForbiddenErrorCode = {
  verification_token_invalid: "verification_token_invalid",
  verification_token_expired: "verification_token_expired",
  verification_invalid: "verification_invalid",
} as const;
